const Routing = () => <>Routing</>;

export { Routing };
